import React, {useEffect, useRef} from 'react'
import {Helmet} from "react-helmet";

function DangerousHtmlRenderer(props) {
  const {html, attribs, node, appendToBody, renderHtml, ...rest} = props
  //console.log({node})
  // const divRef = useRef(null)

  // useEffect(() => {
  //   if (!html) return

  //   const slotHtml = document.createRange().createContextualFragment("<script>" + html + "</script>") // Create a 'tiny' document and parse the html string
  //   divRef.current.innerHTML = '' // Clear the container
  //   divRef.current.appendChild(slotHtml) // Append the new content
  // }, [html])


  //var script = document.createRange().createContextualFragment("<script>" + html + "</script>")
  useEffect(() => {
    var script = document.createElement('script');
    if (node.attribs.src) {
      script.src = node.attribs.src;
    }
    if (html && renderHtml) {
      script.text = html;
    }
    script.onload = function () {
      console.debug('script loaded:');
    };
    if (appendToBody) {
      document.body.appendChild(script);
    } else {
      document.head.appendChild(script);
    }

    return () => {
      console.debug('unloading script:');
      script.remove()
    }
  }, [html])

  return null;
}

export default DangerousHtmlRenderer